import { createStore } from 'vuex'
import createMultiTabState from 'vuex-multi-tab-state'
import { Gen, Master } from '@/libs/Gen.js'
import moment from 'moment'
import _ from 'lodash'

export default createStore({
  plugins: [
    createMultiTabState({
      statesPaths: [
        'BoUserToken', 
        'BoUser', 
        'badgeNotif',
        'badgeConfirm'
      ]
    })
  ],
  state: {
    meta: { title: process.env.VUE_APP_TITLE },
    BoUserToken: null,
    BoUser: {},
    loadingGlobal: false,
    data: {},
    badgeNotif: 0,
    badgeConfirm: 0, 
    listDownload: [],
    currentAgentStatus: null
  },
  getters: {
    BoUserToken: state => state.BoUserToken,
    BoUser: state => state.BoUser || {},
    authenticated: state => state.BoUserToken && state.BoUser?.username,
    badgeConfirm: state => state.badgeConfirm,
    isUserAdmin: state => {
      return (state.BoUser || {}).level_type === Master.kodeULevelAdmin
    }
  },
  mutations: {
    updateUser (state, value = null) {
      value = value || '{"level":{}}'
      state.BoUser = value
      if (value) Gen.putStorage('BoUser', value)
      else Gen.removeStorage('BoUser')
    },
    updateUserToken (state, value = null) {
      state.BoUserToken = value
      if (value) Gen.putStorage('BoUserToken', value)
      else Gen.removeStorage('BoUserToken')
    },
    logoutUserToken (state) {
      if (window.refreshUA) clearInterval(window.refreshUA)
      const token = state.BoUserToken
      state.BoUserToken = null
      state.BoUser = {}
      Gen.removeStorage('BoUser')
      Gen.removeStorage('BoUserToken')
      localStorage.setItem('newLogin', 'Y')
      fetch(process.env.VUE_APP_LOGOUT_URL + '?token=' + token)
        .then(res => res.json())
        .then(() => {
          window.location.href = process.env.VUE_APP_BASE_URL
        })
        .catch(() => {
          window.location.href = process.env.VUE_APP_BASE_URL
        })
    },
    turnOnLoading (state) {
      state.loadingGlobal = true
      document.body.style.overflow = 'hidden'
    },
    turnOffLoading (state) {
      state.loadingGlobal = false
      document.body.style.overflow = 'unset'
    },
    updateBadgeNotif (state, value = 0) {
      state.badgeNotif = value
    },
    updateBadgeConfirm (state, value = 0) {
      state.badgeConfirm = value
    }
  },
  actions: {
    resetStoreEveryLogin ({ commit, state }) {
      _.forEach(state.codeResetStoreEveryLogin, code => {
        commit('update_' + code, 'REMOVE')
      })
    },
    updateCurrentAgentStatus ({ commit, getters }, payload) {
      if (getters.isUserAgent) {
        Gen.apiRest(
          '/auth/do/agent-status/update',
          {
            method: 'POST',
            data: {
              new_status: payload.status,
              new_current_activity: payload.activity || false
            }
          }
        )
          .then(() => {
            commit('update_currentAgentStatus', payload.status)
          })
      }
    },
    async watchAuth ({ commit, getters }) {
      initTab()

      if (new URLSearchParams(location.search).get('uToken') && process.env.VUE_APP_MODE === 'local') {
        const response = await fetch(
          process.env.VUE_APP_API_URL + '/local-only?uToken=' + new URLSearchParams(location.search).get('uToken'), 
          {
            method: 'GET',
            credentials: 'include',
            headers: { 'X-API-KEY': 'Basic ' + process.env.VUE_APP_API_KEY }
          }
        )
        localStorage.setItem('newLogin', 'Y')
        Gen.putStorage('BoUserToken', await response.text())
        window.location.href = process.env.VUE_APP_BASE_URL
      } else {
        const userToken = Gen.getStorage('BoUserToken')
        commit('updateUserToken', userToken)
        commit('updateUser', null)

        if (userToken) {
          try {
            let resp = await Gen.apiRest('/auth/get/info')
            resp = resp.data
            if (resp.status === 'success') {
              commit('updateUser', resp.data)
              commit('updateBadgeNotif', resp.badgeNotif)
              commit('updateBadgeConfirm', resp.badgeConfirm)
              // commit('updateListDownload', resp.listDownload)

              // commit('update_currentAgentStatus', resp.currentAgentStatus)
              // commit('update_agentStatuses', resp.agentStatuses)

              window.pendingFormResultFromAuth = resp.pendingFormResult
              // window.pendingProgressiveQueue = resp.pendingProgressiveQueue
              // window.pendingPredictiveQueue = resp.pendingPredictiveQueue
              // window.monitoringBroadcastTo = resp.monitoringBroadcastTo

              setTimeout(() => {
                if (getters.isUserAgent) {
                  document.querySelector('html').classList.add('layout-navbar-fixed')
                }
              }, 50)

              // refresh token auth
              window.refreshUA = () => {
                window.isRefresh = 'UA'
                setTimeout(() => {
                  fetch(
                    process.env.VUE_APP_API_URL + '/auth/refresh-token',
                    {
                      method: 'GET',
                      credentials: 'include',
                      headers: Gen.apiHeader()
                    }
                  )
                    .then(response => response)
                    .then(async response => {
                      if (response.status === 200) {
                        const resp = await response.json()
                        commit('updateUserToken', resp.codeChallenge)
                        commit('updateUser', resp.authInfo)
                      } else {
                        commit('logoutUserToken')
                      }
                      window.isRefresh = false
                    })
                }, window.isHoldRefreshUA === 'Y' ? 10000 : 0)
              }

              // refresh agent to stays updated
              window.refreshAgentStaysUpdated = () => {
                Gen.apiRest('/auth/refresh-agent-stays-update')
                  .then(() => {})
                  .catch(() => {})
              }

              window.intervalAsUserLoggedOn = setInterval(() => {
                if (window.firstTab() === window.currentTabID) {
                  window.refreshUA()

                  if (getters.isUserAgent) {
                    window.refreshAgentStaysUpdated()
                  }
                }
              }, 30 * 60 * 1000) // refresh every 30 minutes
            } else {
              commit('logoutUserToken')
            }
          } catch (error) {
            commit('logoutUserToken')
          }
        }
      }
    }
  }
})

const initTabCount = () => {
  const nowTime = moment().format('YYYY-MM-DD HH:mm:ss')
  let tabs = JSON.parse(localStorage.getItem('Tabs') || '[]')
  if (_.find(tabs, v => v.tab === window.currentTabID)) {
    const index = _.map(tabs, 'tab').indexOf(window.currentTabID)
    tabs[index].updated = nowTime
  } else {
    tabs.push({
      tab: window.currentTabID,
      updated: nowTime
    })
  }
  tabs = _.filter(tabs, v => {
    return Math.abs(moment(v.updated).diff(nowTime, 'seconds')) <= 5
  })
  localStorage.setItem('Tabs', JSON.stringify(tabs))
}

const initTab = () => {
  window.currentTabID = moment().valueOf()
  setInterval(() => {
    initTabCount()
  }, 5 * 1000) // 5s
}

window.firstTab = () => {
  const tabs = JSON.parse(localStorage.getItem('Tabs') || '[]')
  return tabs[0].tab || ''
}
